import ReactDOM from 'react-dom/client'
import { PortalProviders } from '@portals/shared/PortalProviders'
import { OperationsPortal } from '@portals/operations/OperationsPortal'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <PortalProviders portal="operations">
    <OperationsPortal />
  </PortalProviders>
)
